<template>
  <div class="creat-performance-box">
    <div class="creat-performance-main">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/personal/sign/home' }">签约管理</el-breadcrumb-item>
          <el-breadcrumb-item>发起履约</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="creat-performance-content" v-show="!feedback" v-loading="loading">
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
            label-width="150px"
        >
          <el-form-item label="合同名称：" prop="name">
            <el-input v-model="info.name" placeholder="填写合同名称" disabled></el-input>
          </el-form-item>
          <el-form-item label="履约任务：" prop="taskName">
            <el-input v-model="ruleForm.taskName" placeholder="填写履约任务名称"></el-input>
          </el-form-item>
          <el-form-item label="周期：" prop="performPeriodType" class="period">
            <el-select v-model="ruleForm.performPeriodType" placeholder="请选择履约周期">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首期还款时间：" prop="taskConfirmTime">
            <customer-date-picker
                v-model="ruleForm.taskCommitTime"
                type="datetime"
                placeholder="选择日期"
                :editable="false"
                default-time="23:59:59"
                :value-format="'yyyy-MM-dd HH:mm:ss'"
            ></customer-date-picker>
          </el-form-item>

          <el-form-item label="任务说明：" prop="description" class="explainBox">
            <el-input
                type="textarea"
                v-model="ruleForm.description"
                placeholder="限制50个字符"
                maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="creat-performance-finsh" v-show="feedback">
        <div class="performanceConHead">
          <router-link tag="span" to="/personal/fqPerformance/list">查看履约任务</router-link>
        </div>
        <div class="performancebody">
          <img src="@assets/images/register/success_icon.png" alt>

          <p class="ft16">履约任务创建成功</p>

          <p class="ft12">区块链记录ID:{{ result.txId }}</p>
        </div>
        <div class="performanceTurn">
          <h5>基本信息</h5>
          <div style="overflow:hidden">
            <el-form class="first">
              <el-form-item label="合同名称：">{{ result.contractName }}</el-form-item>
              <el-form-item label="履约任务名称：">{{ result.taskName }}</el-form-item>
              <el-form-item label="合同有效期限：">{{ $moment(result.contractEndDate).format("YYYY-MM-DD") }}
              </el-form-item>
              <el-form-item label="履约创建时间：">{{ result.performCreateTime }}</el-form-item>
              <el-form-item label="任务说明：">
                {{ result.description }}
              </el-form-item>
            </el-form>
            <el-form>
              <el-form-item label="任务执行方：">{{ result.performUserName }}</el-form-item>
              <el-form-item label="任务确认方：">{{ result.confirmUserName }}</el-form-item>
              <el-form-item label="每期还款时间：">{{ result.taskCommitTime }}</el-form-item>
            </el-form>
            <el-form>
              <el-form-item label="证书签发机构：">司法联盟链legalXchain</el-form-item>
              <el-form-item label="签署平台：">广州公证处区块链赋强公证系统</el-form-item>
              <el-form-item label="时间戳：">国家授时中心北斗卫星授时</el-form-item>
            </el-form>
          </div>
          <img src="@assets/images/procedure/preservation_img.png" class="save">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@common/Breadcrumb.vue";
import CustomerDatePicker from "@common/date-picker";
import BaseApi from "@lib/baseApi";
import Util from "@lib/util";
import $ from "jquery";

export default {
  name: "creatPerformance",
  components: {
    Breadcrumb,
    CustomerDatePicker
  },
  data() {
    return {
      id: "",
      info: {},
      result: [],
      feedback: false,
      loading: false,
      /**
       * taskName: 任务名称
       * performPeriodType:周期：1-只一次；2-月；3-季；4-半年；5-年。
       * description:任务说明
       */
      ruleForm: {
        taskName: "",
        performPeriodType: "",
        description: "",
        taskCommitTime: "",
      },
      rules: {
        taskName: [
          {
            required: true,
            message: "请填写履约任务名称",
            trigger: "change,blur"
          },
          {max: 15, message: "任务名称最多15个字", trigger: "blur"}
        ],
        performPeriodType: [{required: true, message: "请选择周期", trigger: "change"}],
        taskCommitTime: [
          {
            required: true,
            message: "请选择任务最晚确认时间",
            trigger: "blur"
          }
        ],
        description: [
          {
            max: 50,
            message: "任务说明1-50个字符",
            trigger: ["blur"]
          }
        ]
      },
      options: [
        {value: "1", label: "单次"},
        {value: "2", label: "按月履约"},
        {value: "3", label: "按季履约"},
        {value: "4", label: "按半年履约"},
        {value: "5", label: "按年履约"}
      ]
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.init();
    this.getOptions();
  },
  methods: {
    getOptions(info) {
      const startDate = this.$moment(info.startDate).format('YYYY-MM-DD');;
      const endDate = this.$moment(info.endDate).format('YYYY-MM-DD');
      const diffMonths = Math.ceil(this.$moment(endDate).diff(startDate, 'months', true));
      if (diffMonths > 6 && diffMonths <= 12) { // 没有年
        this.options.splice(4);
      } else if (diffMonths > 3 && diffMonths <= 6) { // 沒有半年
        this.options.splice(3);
      } else if (diffMonths > 1 && diffMonths <= 3) { // 沒有季
        this.options.splice(2);
      } else if (diffMonths <= 1) { // 只有单次
        this.options.splice(1);
      }
    },
    init() {
      const queryStr = {
        contractId: this.id
      };
      BaseApi.createRpcToken("/perform/performTaskList", queryStr)
          .then(
              data => {
                const {datas: {result: {info}}} = data;
                this.info = info;
                this.getOptions(info);
              }
          )
          .catch(function (e) {
            errorLog(e);
          });
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (!Util.compareTimeToNow(this.ruleForm.taskCommitTime)) {
            this.$message.error("最晚确认时间不能小于当前时间");
            return;
          } else {
            const data = {...this.ruleForm};
            data.contractId = this.id;
            data.contractName = this.info.name;
            this.loading = true;
            console.log(data)
            BaseApi.createRpcToken("/perform/v2/add", data, "post").then(data => {
              this.loading = false;
              this.result = data.datas.result;
              this.feedback = true;
            }).catch(function (e) {
              errorLog(e);
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.creat-performance-box {
  min-height: calc(100vh - 90px);
  height: auto;
  background: #fff;
}

.creat-performance-main {
  padding: 20px 20px 0 20px;
  min-height: calc(100vh - 90px);
  height: auto;
  display: flex;
  flex-direction: column;

  .creat-performance-content {
    flex: 1;
    width: 100%;
    height: calc(100% - 36px);
    padding-top: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: auto;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    /deep/ .el-form {
      .el-form-item {
        width: 100%;

        .el-textarea__inner {
          width: 360px;
        }
      }

      .el-picker-panel__body {
        width: 360px;
      }

      .el-input__inner {
        width: 360px;
        height: 36px;
        line-height: 36px;
        border-radius: 0;
      }

      .el-button--primary {
        width: 120px;
        height: 36px;
        line-height: 36px;
        border: 1px solid #db4437;
        font-size: 14px;
        color: #db4437;
        padding: 0;
        background-color: #fff;
      }
    }
  }

  .creat-performance-finsh {
    width: 100%;
    margin-top: 20px;
    padding-bottom: 20px;

    .performanceConHead {
      width: 100%;
      text-align: right;
      margin-bottom: 16px;

      span {
        cursor: pointer;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        border: 1px solid #e88078;
        font-size: 14px;
        color: #e88078;
        text-align: center;
        margin-left: 10px;

        img {
          vertical-align: middle;
          margin-right: 4px;
        }
      }

      & > span:hover {
        background-color: #D81212;
        border: 1px solid #f0f0f0;
        color: white;
      }

      span:nth-child(1),
      span:nth-child(2) {
        width: 180px;
      }

      span:nth-child(3) {
        width: 100px;
      }
    }

    .performancebody {
      width: 100%;
      height: 394px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      border: 1px solid #e4e8eb;

      img {
        margin-bottom: 12px;
      }

      p {
        color: #505050;
      }

      p:last-child {
        margin-top: 30px;
        text-align: center;
        width: 563px;
        padding: 20px;
        background: #f5f5f5;
        color: #969696;
      }
    }

    .performanceTurn {
      width: 100%;
      border: 1px solid #e4e8eb;
      border-radius: 0 0 3px 3px;
      height: 246px;
      position: relative;

      h5 {
        background: #f5f5f5;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        color: #323232;
        text-indent: 10px;
      }

      .el-form {
        float: left;
        width: calc(100% / 3);
        box-sizing: border-box;
        padding-top: 8px;
        padding-bottom: 8px;

        .el-form-item {
          margin: 0;

          .el-form-item__label {
            width: 110px;
            line-height: 23px;
            font-size: 12px;
            color: #787878;
          }

          .el-form-item__content {
            line-height: 23px;
            font-size: 12px;
            color: #969696;
          }
        }
      }

      .first {
        padding-left: 10px;
      }

      p {
        text-indent: 10px;
        font-size: 12px;
        color: #969696;

        span {
          display: inline-block;
          width: 98px;
          font-size: 12px;
          color: #787878;
          text-align: right;
        }
      }

      .save {
        position: absolute;
        right: 226px;
        bottom: 25px;
        width: 129px;
        height: 106px;
      }
    }
  }
}

/deep/.fullBox {
  padding-bottom: 20px;
  min-height: calc(100% - 20px) !important;
  background: #fff;
}

</style>